export const mutationCreateBooking = `
mutation CreateBooking($createBookingInput: CreateBookingInput!)
{
    createBooking(createBookingInput: $createBookingInput)
    {
        start
        end
        id
        amount
        reference
        isDepositRequired
        gift {
            price
            giftCode
            giftType
        }
    }
}
`;
